module.exports = __webpack_public_path__ + "img/evaluateIcon01.eddc708e.png";